export default {
  methods: {
    supportFeature (featureReference) {
      const features = this.$store.getters['cpAuth/features']

      if (features) {
        return features.indexOf(featureReference) !== -1
      } else {
        return false
      }
    }
  }
}
